<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      客户合同管理
      <small>/客户合同管理列表</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">客户合同管理列表</h4>
              </div>
              <!-- end panel-heading -->
              <el-card class="box-card">
                <div>
                  <div class="top-hd">
                    <el-row>
                      <el-form ref="form" :model="form" label-position="right" label-width="90px" style="width: 80%;">
                        <el-col :span="8">
                          <div class="grid-content bg-purple">
                            <el-form-item label="合同编号：" class="btn1">
                              <el-input v-model="form.goodsName" placeholder="请输入合同编号"></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="grid-content bg-purple-light">
                            <el-form-item label="合同标题：" class="btn1">
                              <el-input v-model="form.pznCode" placeholder="请输入合同标题"></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="8">
                          <div class="grid-content bg-purple">
                            <el-form-item label="服务商：" class="btn1">
                              <el-input v-model="form.barCode" placeholder="请输入服务商名称"></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-form>
                    </el-row>
                  </div>

                  <div class="top-bot">
                    <el-form ref="Formdata" :model="Formdata" :rules="rules" label-width="90px">
                      <el-form-item label="订单时间: " prop="TimeValue">
                        <el-date-picker
                          v-model="Formdata.TimeValue"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          @change="ChangePicker"
                          align="center"
                        ></el-date-picker>
                      </el-form-item>
                    </el-form>
                  </div>
                  <div class="bot-btn">
                    <el-button class="btn btn-primary btn-sm ButtonColor" @click="chaxun()">查询</el-button>
                    <!-- <el-button type="primary" @click="addc()">新增合同</el-button> -->
                    <el-button class="btn btn-primary btn-sm ButtonColor bot-btn-left"  @click="exp()">导出</el-button>
                  </div>
                  <!-- 03 -->
                  <div >
                    <el-table
                      :data="tableData3"
                      style="width: 100%"
                      size="medium"
                      border
                      :header-cell-style="{background:'#ffffff'}"
                    >
                      <el-table-column
                        width="50"
                        prop="goodsid"
                        label="序号"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="150"
                        prop="goodsName"
                        label="合同编号"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="pznCode"
                        label="合同标题"
                        align="center"
                        resizable
                      ></el-table-column>

                      <el-table-column
                        width="100"
                        prop="pznCode"
                        label="合同区域"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="pznCode"
                        label="合同品类"
                        align="center"
                        resizable
                      ></el-table-column>

                      <el-table-column
                        width="100"
                        prop="pznCode"
                        label="分销商类型"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="100"
                        prop="pznCode"
                        label="分销商名称"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="160"
                        prop="barCode"
                        label="客户签订时间"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="160"
                        prop="barCode"
                        label="企业签订时间"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="180"
                        prop="barCode"
                        label="企业合同下载地址"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="160"
                        prop="barCode"
                        label="客户合同下载地址"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column width="345" label="操作" align="center" resizable>
                        <template slot-scope="scope">
                          <el-button
                            class="btn btn-primary btn-sm ButtonColor"
                            icon="el-icon-edit"
                            size="small"
                            @click="edit(scope.row)"
                          >编辑</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- 04 -->
                  <div class="bottom">
                    <div class="block">
                      <!---- totalCount  ------- pageSize   ----->
                      <el-pagination
                        :current-page="pageNo"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        background
                      ></el-pagination>
                    </div>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
      <el-dialog title :visible.sync="outerVisible" width="50%">
        <!-- 编辑和  新增 -->
        <div v-if="EditDialog === 1" class="ModelPadding">
          <div class="swal-title" style="margin-top:0px">{{DialogTitle}}</div>

          <!-- 新增 -->

          <el-form
            :model="ruleForm"
            :inline="true"
            :rules="rules"
            ref="ruleForm"
            label-width="150px"
            class="demo-form-inline"
          >
            <el-form-item label="合同编号:" prop="recom" class="labelstyle">
              <el-input
                v-model="ruleForm.recom"
                class="DistributorMargin InputWidth"
                style="width:100%"
              ></el-input>
            </el-form-item>
            <el-form-item label="合同标题:" prop="recomName" class="labelstyle">
              <el-input v-model="ruleForm.recomName" class="DistributorMargin InputWidth"></el-input>
            </el-form-item>
            <el-form-item label="合同区域:" prop="area" class="labelstyle">
              <el-input v-model="ruleForm.area" class="DistributorMargin InputWidth"></el-input>
            </el-form-item>
            <el-form-item label="新增品类:" prop="groupId" class="labelstyle">
              <el-select
                v-model="ruleForm.groupId"
                clearable
                placeholder="请选择"
                class="DistributorMargin InputWidth"
              >
                <el-option
                  v-for="item in GroupList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户类型:" prop="type" class="labelstyle">
              <el-select
                v-model="ruleForm.type"
                clearable
                placeholder="请选择"
                class="DistributorMargin InputWidth"
              >
                <el-option
                  v-for="item in typeList"
                  :key="item.key"
                  :label="item.value"
                  :value="item.key"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称:" prop="loginUser" class="labelstyle">
              <el-input
                v-model="ruleForm.loginUser"
                autocomplete="new-password"
                class="DistributorMargin InputWidth"
              ></el-input>
            </el-form-item>
            <div class="clear"></div>
            <div class="upload">
              <div class="upload_left">上传合同：</div>
              <div>
                <!-- 后端接口 -->
                <el-upload
                  action="https://jsonplaceholder.typicode.com/posts/"
                  list-type="picture-card"
                  :headers="headers"
                  :on-preview="handlePictureCardPreview"
                  :on-remove="handleRemove"
                  :on-error="handleErr"
                  :on-success="handleSuccess"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
                <el-dialog :visible.sync="dialogVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </div>
            </div>
            <div class="upload">
              <div class="upload_left">备注：</div>
              <div class="upload_right">
                <el-input
                  v-model="ruleForm.bz"
                  type="textarea"
                  class="DistributorMargin InputWidth"
                ></el-input>
              </div>
            </div>
          </el-form>

          <div class="swal-footer">
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--confirm btn btn-primary"
                @click="MakeSureEdit('ruleForm')"
                :disabled="disabled"
              >提交</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="outerVisible = false"
              >取消</div>
            </div>
          </div>
        </div>

        <!-- 删除 -->
        <div v-if="EditDialog === 2" class="ModelPadding">
          <div class="swal-icon swal-icon--info"></div>
          <div class="swal-title">您确定吗?</div>
          <div class="swal-text" style="text-align:center">您将无法恢复这个文件!</div>
          <div class="swal-footer">
            <div class="swal-button-container">
              <button
                class="swal-button swal-button--confirm btn btn-primary"
                @click="MakeSure"
                :disabled="disabled"
              >确定</button>
            </div>
            <div class="swal-button-container">
              <div
                class="swal-button swal-button--cancel btn btn-default"
                @click="outerVisible = false"
              >取消</div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "contract",
  data() {
    var checkrecom = (rule, value, callback) => {
      setTimeout(() => {
        var reg = /^[0-9A-Za-z]{1,16}$/;
        if (!reg.test(value)) {
          callback(new Error("合同编号由数字和字母组成且小于16位"));
        } else {
          callback();
        }
      }, 1000);
    };
    var checkrecomName = (rule, value, callback) => {
      setTimeout(() => {
        if (value.length > 32) {
          callback(new Error("名称必须小于33位"));
        } else {
          callback();
        }
      }, 1000);
    };
    // 合同区域
    var checkarea = (rule, value, callback) => {
      setTimeout(() => {
        if (value.length > 32) {
          callback(new Error("名称必须小于33位"));
        } else {
          callback();
        }
      }, 1000);
    };

    return {
        // 上传合同，
      dialogImageUrl: "",
      dialogVisible: false,
      // token
      headers: {
        Authorization: JSON.parse(localStorage.getItem("Authorization"))
          .Authorization // 直接从本地获取token就行
      },
      // 对话框

      outerVisible: false,
      DialogTitle: "编辑",
      disabled: false,
      EditDialog: 1,
      CurrentSelection: [],
      ruleForm: {
        groupId: ""
      },
      // 当前页  ---- 默认显示第几页
      // current: 1,
      pageNo: 1,
      // 当前显示 数据的数据量
      pageSize: 10,
      // 数据总数量  ---- 总条数
      totalCount: 0,

      // 开始时间  （yyyy-MM-dd HH:mm:ss）
      startTime: "",
      // 结束时间  （yyyy-MM-dd HH:mm:ss）
      endTime: "",
      form: {
        // 商品名称
        goodsName: "",
        // 料号
        pznCode: "",
        // 条形码
        barCode: ""
      },
      rules: {
        recom: [
          { required: true, message: "请输入合同编号", trigger: "blur" },
          { validator: checkrecom, trigger: "blur" }
        ],
        recomName: [
          { required: true, message: "请输入合同标题", trigger: "blur" },
          { validator: checkrecomName, trigger: "blur" }
        ],
        // 合同区域
        area: [
          { required: true, message: "请输入合同区域", trigger: "blur" },
          { validator: checkarea, trigger: "blur" }
        ],
        //  客户名称
        loginUser: [
          { required: true, message: "请输入客户名称", trigger: "blur" },
          { validator: checkrecomName, trigger: "blur" }
        ],
        groupId: [{ required: true, message: "请选择", trigger: "change" }],
        //客户类型
        type: [{ required: true, message: "请选择客户类型", trigger: "change" }]
      },

      // 新增品类
      GroupList: [
         { key: 0, value: "服务商" },
        { key: 1, value: "分销商" }
      ],
      // 合同类型
      typeList: [
        { key: 0, value: "服务商" },
        { key: 1, value: "分销商" }
      ],
      Formdata: {
        // TimeValue: [new Date(2020, 0, 1), new Date()],
        TimeValue: ""
      },
      //   表格的 数据
      tableData3: [
        {
          //  条形码
          barCode: "2020-02-16 12:23:34",
          // 品牌
          brand: "",
          // 商品名称
          goodsName: "",
          inputCount: 0,
          inputTime: 0,
          // 备案号
          itemNo: "",
          // 中台商品id
          mmsGoodId: "",
          // 料号
          pznCode: "",
          typeGoodId: "",
          // 仓库名称
          warehouseName: ""
        },
        {
          //  条形码
          barCode: "2020-02-16 12:23:34",
          // 品牌
          brand: "",
          // 商品名称
          goodsName: "",
          inputCount: 0,
          inputTime: 0,
          // 备案号
          itemNo: "",
          // 中台商品id
          mmsGoodId: "",
          // 料号
          pznCode: "",
          typeGoodId: "",
          // 仓库名称
          warehouseName: ""
        },
        {
          //  条形码
          barCode: "2020-02-16 12:23:34",
          // 品牌
          brand: "",
          // 商品名称
          goodsName: "",
          inputCount: 0,
          inputTime: 0,
          // 备案号
          itemNo: "",
          // 中台商品id
          mmsGoodId: "",
          // 料号
          pznCode: "",
          typeGoodId: "",
          // 仓库名称
          warehouseName: ""
        },
        {
          //  条形码
          barCode: "2020-02-16 12:23:34",
          // 品牌
          brand: "",
          // 商品名称
          goodsName: "",
          inputCount: 0,
          inputTime: 0,
          // 备案号
          itemNo: "",
          // 中台商品id
          mmsGoodId: "",
          // 料号
          pznCode: "",
          typeGoodId: "",
          // 仓库名称
          warehouseName: ""
        },
        {
          //  条形码
          barCode: "2020-02-16 12:23:34",
          // 品牌
          brand: "",
          // 商品名称
          goodsName: "",
          inputCount: 0,
          inputTime: 0,
          // 备案号
          itemNo: "",
          // 中台商品id
          mmsGoodId: "",
          // 料号
          pznCode: "",
          typeGoodId: "",
          // 仓库名称
          warehouseName: ""
        },
        {
          //  条形码
          barCode: "2020-02-16 12:23:34",
          // 品牌
          brand: "",
          // 商品名称
          goodsName: "",
          inputCount: 0,
          inputTime: 0,
          // 备案号
          itemNo: "",
          // 中台商品id
          mmsGoodId: "",
          // 料号
          pznCode: "",
          typeGoodId: "",
          // 仓库名称
          warehouseName: ""
        }
      ]
      //
    };
  },
  created() {
    console.log(this.headers);
  },
  mounted() {
    // this.startTime = this.getstarttime();
    // // endTime结束时间
    // this.endTime = this.getEndtime();
    // this.getUrl();
    // this.initData();
  },
  methods: {
    // 初始化数据
    initData() {
      // 短消息的  中this
      let that = this;
      const options = {
        url: "/statistics/purchaseController/queryPurchaseInfo", //   1
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        // 请求参数
        data: Qs.stringify({
          // 商品名称
          goodName:
            // "Swisse高强度蔓越莓胶囊25000mg30粒",
            that.form.goodsName,
          //料号
          pznCode: that.form.pznCode,
          // 条形码
          barCode: that.form.barCode,
          // 开始时间  （yyyy-MM-dd HH:mm:ss）
          beginTime: that.startTime,
          // 结束时间  （yyyy-MM-dd HH:mm:ss）
          endTime: that.endTime,
          // 当前页码
          pageNo: that.pageNo,
          // 当前显示 数据的数据量
          pageSize: that.pageSize
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          for (var i = 0; i < response.data.data.purchaseInfoList.length; i++) {
            //  goodsid  为  自定义  属性 --- 【序号】
            response.data.data.purchaseInfoList[i].goodsid =
              Number((that.pageNo - 1) * that.pageSize) + Number(i) + 1;
          }
          this.tableData3 = response.data.data.purchaseInfoList;
          // console.log(response.data.data.purchaseInfoList)   //  10   ?
          this.totalCount = response.data.data.totalCount;
        } else {
          that.$notify({
            title: "失败",
            message: response.data.message,
            type: "error"
          });
        }
      });
    },
    // 查询数据
    chaxun() {
      if (!this.startTime || !this.endTime) {
        this.$notify({
          title: "失败",
          message: "查询时间不能为空",
          type: "error"
        });
        return;
      } else {
        // 短消息的  中this
        this.initData();
        // this.pageNo = 1
      }
    },
    addc() {
      console.log("新增合同 ");
      this.ruleForm = {};
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.outerVisible = true;
      this.DialogTitle = "新增";
      this.EditDialog = 1;
      // this.$router.push({ name: "addcontract", path: "/addcontract" });
    },
    // 事件处理函数
    MakeSureEdit(formName) {
      let that = this;
      if (this.DialogTitle === "编辑") {
        console.log("编辑");
        // that.$refs[formName].validate(valid => {
        //   if (valid) {
        //     that.disabled = true;
        //     const options = {
        //       url: "distribution/B2cGoodsBrandController/updateBrand",
        //       method: "post",
        //       headers: { "Content-Type": "application/x-www-form-urlencoded" },
        //       data: Qs.stringify({
        //         brandId: this.ruleForm.brandId,
        //         brandCode: this.ruleForm.brandCode,
        //         brandName: this.ruleForm.brandName.replace(/\s+/g, ""),
        //         noted: this.ruleForm.noted
        //       })
        //     };
        //     axios(options)
        //       .then(function(response) {
        //         that.outerVisible = false;
        //         that.disabled = false;
        //         if (response.data.code == 200) {
        //           that.initdata();
        //           that.$notify({
        //             title: "成功",
        //             message: "修改成功",
        //             type: "success"
        //           });
        //         } else {
        //           http.handleEorrorCode(response, that);
        //         }
        //       })
        //       .catch(function(error) {
        //         that.outerVisible = false;
        //         that.disabled = false;
        //         http.handleHttpError(error, that);
        //       });
        //   } else {
        //     this.outerVisible = true;
        //   }
        // });
      } else if (this.DialogTitle === "新增") {
        that.$refs[formName].validate(valid => {
          if (valid) {
            that.disabled = true;
            const options = {
              url: "distribution/B2cGoodsBrandController/addBrand",
              method: "post",
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
              data: Qs.stringify({
                brandCode: this.ruleForm.brandCode,
                brandName: this.ruleForm.brandName.replace(/\s+/g, ""),
                noted: this.ruleForm.noted
              })
            };
            axios(options)
              .then(function(response) {
                that.outerVisible = false;
                that.disabled = false;
                if (response.data.code == 200) {
                  that.initdata();
                  that.$notify({
                    title: "成功",
                    message: "新增成功",
                    type: "success"
                  });
                } else {
                  http.handleEorrorCode(response, that);
                }
              })
              .catch(function(error) {
                that.outerVisible = false;
                that.disabled = false;
                http.handleHttpError(error, that);
              });
          } else {
            this.outerVisible = true;
          }
        });
      } else if (this.DialogTitle === "下载合同") {
        console.log("下载合同");
        this.outerVisible = false;
      }
    },
    // 上传合同的处理函数
    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 上传成功
    handleSuccess(response, file, fileList){
      console.log(response)
    },
   handleErr(err, file, fileLis){
     console.log(err)
   },
    // 导出数据
    exp() {
      let that = this;
      const options = {
        url: "/statistics/purchaseController/queryExcelPurchaseInfo",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        // 请求参数
        data: Qs.stringify({
          goodName: that.form.goodsName,
          pznCode: that.form.pznCode,
          barCode: that.form.barCode,
          //  开始时间
          beginTime: that.startTime,
          // 结束时间  （yyyy-MM-dd HH:mm:ss）
          endTime: that.endTime
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          }
        })
        .catch(error => {
          http.handleHttpError(error, this);
        });
    },
    // 详情的处理函数
    handleClick(row, index) {
      this.$router.push({ name: "contractdetail", path: "/contractdetail" });
      console.log(row); //   当前行的值
      console.log(index); //  当前 行
      console.log(row.barCode);
    },
    // 删除的 处理函数
    del(item) {
      //console.log(row);
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    // 编辑函数
    edit(item) {
      // this.$router.push({ path: "/editcontract" });

      this.outerVisible = true;
      this.DialogTitle = "编辑";
      this.EditDialog = 1;
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.ruleForm = MethodsBus.cloneRow(item);
      console.log(this.ruleForm);
    },
    // 下载
    xz(item) {
      console.log("下载合同");
      console.log(item);
    },
    // 对话框的 【确定 】 处理函数
    MakeSure() {
      this.outerVisible = true;
    },
    //   startTime  开始时间
    getstarttime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth() + 1; //得到月份
      var date = now.getDate(); //得到日期
      //   var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒

      if (now.getMonth() + 1) {
        if (month < 10) month = "0" + (now.getMonth() + 1);
        date = "0" + "1";
        hour = "0" + "0";
        minu = "0" + "0";
        sec = "0" + "0";
      }
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    // endtime;结束时间
    getEndtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    //  时间的处理函数
    ChangePicker() {
      if (this.Formdata.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.Formdata.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.Formdata.TimeValue[1]);
      } else if (this.Formdata.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    // 分页处理函数 分页-- 获取 每页  value条
    handleSizeChange(value) {
      this.pageSize = value;
      console.log(this.pageSize);
      this.pageNo = 1;
      this.initData();
    },
    //  获取 当前  value
    handleCurrentChange(value) {
      this.pageNo = value;
      console.log(this.pageNo);
      this.initData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
.GContent {
  padding: 15px;
  border: 1px #e5e5e5 solid;
  border-top: none;
}
.top-hd {
  margin-top: 20px;
}
.text {
  font-size: 14px;
}

.upload {
  margin-top: 20px;
  margin-left: 17%;
  display: flex;
  justify-content: flex-start;
}
.upload_left {
  margin-top: 50px;
  padding-right: 20px;
  letter-spacing: 1px;
}
.upload_right {
  margin-top: 45px;
}
.item {
  margin-bottom: 18px;
}
.swal-footer {
  text-align: center;
}
.swal-button-container {
  margin-left: 24px;
}
.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}

.bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.bottom_table {
  display: flex;
  justify-content: flex-start;
}

.grid-content {
  border-radius: 4px;
  min-height: 20px;
}
.top-thone {
  margin-left: 20px;
  margin-top: 20px;
}
.btn1 {
  background-color: #fff;
}
.bot-btn {
  float: left;
  margin-left: 48%;
}
.bot-btn-left {
  margin-left: 70px;
}
.top-bot {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/DistributorManage/clientcontract.vue